export type UnLocalizedPath = string | RegExp;

export const unLocalizedPaths: UnLocalizedPath[] = [/^\/blog(\/.*)?$/, /^\/survey-thanks/];
